// src/components/AppLayout.jsx

import React, { useMemo, useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Avatar,
  Dropdown,
  Typography,
  Tag,
  Space,
  Badge,
  Tooltip,
} from "antd";
import {
  DashboardOutlined,
  LogoutOutlined,
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  SafetyCertificateOutlined,
  IdcardOutlined,
  BankOutlined,
  StarOutlined,
  FileTextOutlined,
  ApartmentOutlined,
  BellOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation, Outlet, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Cookies from "js-cookie";
import { getNotificationApi } from "../api/master.api";
import api from "../api/axios";
import { placeholderImg } from "../Entryfile/imagepath";

const { Sider, Header, Content } = Layout;
const { Text } = Typography;

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);

  // ── Notification & Employee state (from CaseHeader) ──────────────────────
  const [notificationData, setNotificationData] = useState({});
  const [employeeData, setEmployeeData] = useState({});
  console.log(user);
  const logInStatus = parseInt(Cookies.get("Role"));
  const employeeId = user?.employee_id;
  const userName = user?.name || "";

  // const showNotifications =
  //   logInStatus === 1 || logInStatus === 2 || logInStatus === 7;

  // Fetch employee profile photo
  // useEffect(() => {
  //   if (!employeeId) return;
  //   api
  //     .get(`/employees/${employeeId}`)
  //     .then(({ data: body }) => setEmployeeData(body?.data?.employee || {}))
  //     .catch((err) => console.error(err));
  // }, [employeeId]);

  // Fetch notifications
  useEffect(() => {
    getNotificationApi()
      .then(({ data: body }) => {
        // console.log(body);
        setNotificationData(body?.data || {});
      })
      .catch((err) => console.error(err));
  }, []);

  const totalNotifications =
    (notificationData?.appeal?.length || 0) +
    (notificationData?.high?.length || 0) +
    (notificationData?.district?.length || 0);

  // ── Sidebar auto-open ─────────────────────────────────────────────────────
  useEffect(() => {
    const path = location.pathname;
    const getParentKey = (path) => {
      if (path.includes("appeal-court") || path.includes("appel"))
        return ["supreme", "appeal"];
      if (path.includes("high-court")) return ["supreme", "high"];
      if (path.includes("tribunal")) return ["tribunal"];
      if (path.includes("district-court") || path.includes("other-court"))
        return ["others"];
      if (path.includes("law")) return ["lawyer"];
      if (path.includes("summary")) return ["summary"];
      if (path.includes("setting")) return ["settings"];
      if (path.includes("admin") || path.includes("users"))
        return ["admin-settings"];
      return [];
    };
    setOpenKeys(getParentKey(path));
  }, [location.pathname]);

  // ── Sidebar hover-expand ──────────────────────────────────────────────────
  const handleMouseEnter = () => {
    if (collapsed) setIsHovered(true);
  };
  const handleMouseLeave = () => setIsHovered(false);
  const isVisuallyCollapsed = collapsed && !isHovered;

  // ── Logout ────────────────────────────────────────────────────────────────
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // ── Menu items ────────────────────────────────────────────────────────────
  const menuItems = useMemo(
    () => [
      { key: "/dashboard", icon: <DashboardOutlined />, label: "ড্যাশবোর্ড" },
      {
        key: "supreme",
        icon: <BankOutlined />,
        label: "বাংলাদেশ সুপ্রীম কোর্ট",
        children: [
          {
            key: "appeal",
            icon: <ApartmentOutlined />,
            label: "মহামান্য আপিল বিভাগ",
            children: [
              ...(user.role === "admin"
                ? [
                    {
                      key: "/appel-division-entry",
                      label: "নতুন/চলমান আপিল মামলা এন্ট্রি",
                    },
                  ]
                : []),

              {
                key: "/report/appeal-court/all-case",
                label: "সকল মামলার তালিকা",
              },
              {
                key: "/report/appeal-court/running-case",
                label: "চলমান মামলার তালিকা",
              },
              {
                key: "/report/appeal-court/close-case",
                label: "নিষ্পত্তিকৃত মামলার তালিকা",
              },
            ],
          },
          {
            key: "high",
            icon: <ApartmentOutlined />,
            label: "মহামান্য হাইকোর্ট বিভাগ",
            children: [
              ...(user.role === "admin"
                ? [
                    {
                      key: "/high-court-case-entry",
                      label: "নতুন/চলমান হাইকোর্ট মামলা এন্ট্রি",
                    },
                  ]
                : []),

              {
                key: "/report/high-court/all-case",
                label: "সকল মামলার তালিকা",
              },
              {
                key: "/report/high-court/running-case",
                label: "চলমান মামলার তালিকা",
              },
              {
                key: "/report/high-court/close-case",
                label: "নিষ্পত্তিকৃত মামলার তালিকা",
              },
            ],
          },
        ],
      },
      {
        key: "tribunal",
        icon: <BankOutlined />,
        label: "THREE-MEMBER ARBITRAL TRIBUNAL",
        children: [
          ...(user.role === "admin"
            ? [{ key: "/three-member-tribunal", label: "এন্ট্রি" }]
            : []),

          {
            key: "/report/tribunal-court/all-case",
            label: "সকল মামলার তালিকা",
          },
          {
            key: "/report/tribunal-court/running-case",
            label: "চলমান মামলার তালিকা",
          },
          {
            key: "/report/tribunal-court/close-case",
            label: "নিষ্পত্তিকৃত মামলার তালিকা",
          },
        ],
      },
      {
        key: "others",
        icon: <BankOutlined />,
        label: "অন্যান্য অধস্তন আদালত",
        children: [
          ...(user.role === "admin"
            ? [{ key: "/other-court-entry", label: "অন্যান্য আদালত এন্ট্রি" }]
            : []),

          {
            key: "/report/district-court/all-case",
            label: "সকল মামলার তালিকা",
          },
          {
            key: "/report/district-court/running-case",
            label: "চলমান মামলার তালিকা",
          },
          {
            key: "/report/district-court/close-case",
            label: "নিষ্পত্তিকৃত মামলার তালিকা",
          },
        ],
      },
      {
        key: "/important-running-case",
        icon: <StarOutlined />,
        label: "গুরুত্বপূর্ণ চলমান মামলা",
      },
      {
        key: "lawyer",
        icon: <IdcardOutlined />,
        label: "আইন উপদেষ্টা ও প্যানেল আইনজীবী",
        children: [
          ...(user.role === "admin"
            ? [{ key: "/lawyer-entry", label: "নতুন এন্ট্রি" }]
            : []),

          { key: "/lawadvicer", label: "আইন উপদেষ্টা" },
          { key: "/panellawyer", label: "প্যানেল আইনজীবী" },
        ],
      },
      // {
      //   key: "summary",
      //   icon: <FileTextOutlined />,
      //   label: "মামলার সংক্ষিপ্ত বিবরণী",
      //   children: [
      //      ...(user.role === "admin"
      //           ? [  { key: "/case-summary-entry", label: "নতুন এন্ট্রি" }]
      //           : []
      //         ),

      //     { key: "/case-summary-report", label: "কেস রিপোর্ট" },
      //   ],
      // },
      {
        key: "settings",
        icon: <SettingOutlined />,
        label: "সেটিং",
        children: [
          ...(user.role === "admin"
            ? [
                { key: "/setting/case-category", label: "মামলার ক্যাটাগরি" },
                {
                  key: "/setting/case-type",
                  label: "মামলার শ্রেণী / কেস-টাইপ",
                },
                { key: "/setting/justice-name", label: "আদালতের নাম" },
                {
                  key: "/setting/related-law-officer",
                  label: "সংশ্লিষ্ট আইন কর্মকর্তা",
                },
                {
                  key: "/setting/related-law-officer-name",
                  label: "আইন কর্মকর্তার নাম",
                },
              ]
            : []),
        ],
      },
      {
        key: "admin-settings",
        icon: <SettingOutlined />,
        label: "Administration Setting",
        children: [
          ...(user.role === "admin"
            ? [
                {
                  key: "/users",
                  icon: <UserOutlined />,
                  label: "User Management",
                },
                {
                  key: "/admin/employees",
                  icon: <IdcardOutlined />,
                  label: "Employee Management",
                },
              ]
            : []),
        ],
      },
    ],
    [],
  );

  const selectedKeys = [location.pathname];

  // ── Profile dropdown (with photo, My Profile, Change Password, Logout) ───
  const profileMenuItems = {
    items: [
      {
        key: "name",
        label: (
          <span style={{ fontWeight: 600, color: "#630063" }}>{userName}</span>
        ),
        disabled: true,
      },
      { type: "divider" },
      {
        key: "profile",
        icon: <UserOutlined />,
        label: <a href="/profile">My Profile</a>,
      },

      { type: "divider" },
      {
        key: "logout",
        icon: <LogoutOutlined />,
        label: "Logout",
        danger: true,
        onClick: handleLogout,
      },
    ],
  };

  // ── Notification dropdown content ────────────────────────────────────────
  const NotificationSection = ({ title, items, linkTo }) => (
    <>
      <div style={styles.notiSectionHeader}>
        <BellOutlined style={{ marginRight: 6, color: "#630063" }} />
        <span style={styles.notiSectionTitle}>{title}</span>
        <span style={styles.notiSectionCount}>{items?.length || 0}</span>
      </div>
      {items?.map((item, idx) => (
        <Link to={linkTo} key={idx}>
          <div style={styles.notiItem}>
            <div style={styles.notiCaseNo}>মামলা নং: {item?.case_number}</div>
            <div style={styles.notiDate}>
              পরবর্তী শুনানি: {item?.next_hearing_date}
            </div>
          </div>
        </Link>
      ))}
    </>
  );

  const notificationDropdownContent = (
    <div style={styles.notiDropdown}>
      {/* Header */}
      <div style={styles.notiHeader}>
        <span style={styles.notiHeaderTitle}>Notifications</span>
        {/* <button style={styles.clearBtn} onClick={() => setNotificationData({})}>
          Clear All
        </button> */}
      </div>

      {/* Scrollable body */}
      <div style={styles.notiBody}>
        <NotificationSection
          title="আপিল বিভাগ"
          items={notificationData?.appeal}
          linkTo="/report/appeal-court/all-case"
        />
        <NotificationSection
          title="হাইকোর্ট বিভাগ"
          items={notificationData?.high}
          linkTo="/report/high-court/all-case"
        />
        <NotificationSection
          title="জেলা জজ আদালত"
          items={notificationData?.district}
          linkTo="/report/district-court/all-case"
        />
      </div>

      {/* Footer */}
      <div style={styles.notiFooter}>
        <Link to="/case/notifications" style={styles.viewAllLink}>
          View all Notifications
        </Link>
      </div>
    </div>
  );

  // ── Employee photo src ────────────────────────────────────────────────────
  const photoSrc = employeeData?.photo_path
    ? `http://192.168.3.8:2001/static${employeeData.photo_path}`
    : placeholderImg;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* ── Sidebar ───────────────────────────────────────────────────────── */}
      <Sider
        collapsible
        collapsed={isVisuallyCollapsed}
        onCollapse={setCollapsed}
        trigger={null}
        width={260}
        collapsedWidth={64}
        style={{
          background: "#630063",
          transition: "all 0.3s ease",
          zIndex: 1000,
          position: "fixed",
          height: "100vh",
          left: 0,
          top: 0,
          bottom: 0,
          overflowY: "auto", // ✅ ADD THIS
          overflowX: "hidden",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div
          style={{
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* <Text style={{ color: "#fff" }}>⬡ Dashboard ⬡</Text> */}
        </div>

        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKeys}
          openKeys={isVisuallyCollapsed ? [] : openKeys}
          onOpenChange={(keys) => setOpenKeys(keys)}
          onClick={({ key }) => navigate(key)}
          items={menuItems}
          inlineCollapsed={isVisuallyCollapsed}
          style={{ background: "#630063" }}
        />
      </Sider>

      {/* ── Main layout ───────────────────────────────────────────────────── */}
      <Layout
        style={{
          marginLeft: isVisuallyCollapsed ? 64 : 260,
          transition: "margin-left 0.3s ease",
        }}
      >
        {/* ── Header ──────────────────────────────────────────────────────── */}
        <Header style={styles.header}>
          {/* Left: collapse toggle */}
          <div
            onClick={() => setCollapsed(!collapsed)}
            style={styles.collapseBtn}
          >
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </div>

          {/* Center: title */}
          <div style={styles.headerTitle}>Case Management System</div>

          {/* Right: notification bell + profile */}
          <Space size={16} align="center">
            {/* Notification Bell (role-gated) */}
            {/* {showNotifications && ( */}
            <Dropdown
              overlay={notificationDropdownContent}
              trigger={["click"]}
              placement="bottomRight"
            >
              <Tooltip title="Notifications">
                <Badge count={totalNotifications} size="small" offset={[-2, 2]}>
                  <div style={styles.bellBtn}>
                    <BellOutlined style={{ fontSize: 18, color: "#fff" }} />
                  </div>
                </Badge>
              </Tooltip>
            </Dropdown>
            {/* )} */}

            {/* Role tag */}
            {/* <Tag color="purple" style={styles.roleTag}>{user?.role}</Tag> */}

            {/* Profile dropdown with photo */}
            <Dropdown menu={profileMenuItems} placement="bottomRight">
              <div style={styles.profileBtn}>
                <Avatar
                  src={photoSrc}
                  icon={<UserOutlined />}
                  size={36}
                  style={{
                    border: "2px solid rgba(255,255,255,0)",
                    cursor: "pointer",
                  }}
                />
                <span style={styles.profileName}>{userName}</span>
              </div>
            </Dropdown>
          </Space>
        </Header>

        {/* ── Content ─────────────────────────────────────────────────────── */}
        <Content style={{ background: "#fff" }}>
          <Outlet />
        </Content>
      </Layout>

      {/* ── Global CSS ───────────────────────────────────────────────────── */}
      <style>{`
        /* ── Sidebar expanded ── */
        .ant-layout-sider:not(.ant-layout-sider-collapsed) .ant-menu-item,
        .ant-layout-sider:not(.ant-layout-sider-collapsed) .ant-menu-submenu-title {
          height: auto !important;
          line-height: 1.4 !important;
          padding-top: 10px !important;
          padding-bottom: 10px !important;
          padding-left: 24px !important;
          white-space: normal !important;
        }
        .ant-layout-sider:not(.ant-layout-sider-collapsed) .ant-menu-item span,
        .ant-layout-sider:not(.ant-layout-sider-collapsed) .ant-menu-submenu-title span {
          white-space: normal !important;
          word-break: break-word;
        }

        /* ── Sidebar collapsed ── */
        .ant-layout-sider-collapsed .ant-menu-item,
        .ant-layout-sider-collapsed .ant-menu-submenu-title {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 0 !important;
          margin: 0 auto !important;
          text-align: center !important;
        }
        .ant-layout-sider-collapsed .ant-menu-item .anticon,
        .ant-layout-sider-collapsed .ant-menu-submenu-title .anticon {
          font-size: 20px !important;
          margin: 0 !important;
          display: inline-block !important;
        }
        .ant-layout-sider-collapsed .ant-menu-item span:not(.anticon),
        .ant-layout-sider-collapsed .ant-menu-submenu-title span:not(.anticon) {
          display: none !important;
        }
        .ant-layout-sider-collapsed .ant-menu-submenu-arrow { display: none !important; }
        .ant-layout-sider-collapsed { min-width: 64px !important; width: 64px !important; max-width: 64px !important; }
        .ant-layout-sider-collapsed .ant-menu-item:hover,
        .ant-layout-sider-collapsed .ant-menu-submenu-title:hover {
          background: rgba(255,255,255,0.15) !important;
        }

        /* ── Submenu popup ── */
        .ant-menu-submenu-popup .ant-menu { background: #630063 !important; }
        .ant-menu-submenu-popup .ant-menu-item,
        .ant-menu-submenu-popup .ant-menu-submenu-title {
          padding: 8px 16px !important;
          margin: 0 !important;
        }
        .ant-menu-submenu-popup .ant-menu-item:hover,
        .ant-menu-submenu-popup .ant-menu-submenu-title:hover {
          background: rgba(255,255,255,0.1) !important;
        }

        /* ── Sider transition ── */
        .ant-layout-sider { transition: all 0.3s ease !important; }
        .ant-layout-sider:hover { box-shadow: 2px 0 8px rgba(0,0,0,0.15); }

        /* ── Notification item hover ── */
        .noti-item-link:hover > div { background: #f5f0f7 !important; }
      `}</style>
    </Layout>
  );
};

// ── Inline styles object ─────────────────────────────────────────────────────
const styles = {
  header: {
    background: "#783978",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 20px",
    position: "sticky",
    top: 0,
    zIndex: 999,
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  },
  collapseBtn: {
    cursor: "pointer",
    color: "#fff",
    fontSize: 18,
    display: "flex",
    alignItems: "center",
  },
  headerTitle: {
    color: "#fff",
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: "0.5px",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    pointerEvents: "none",
    whiteSpace: "nowrap",
  },
  bellBtn: {
    cursor: "pointer",
    width: 36,
    height: 36,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s",
  },
  roleTag: {
    margin: 0,
    fontWeight: 500,
    letterSpacing: "0.3px",
  },
  profileBtn: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: 20,
    // background: "rgba(255,255,255,0.12)",
    transition: "background 0.2s",
  },
  profileName: {
    color: "#fff",
    fontSize: 13,
    fontWeight: 500,
    maxWidth: 120,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // ── Notification dropdown ──
  notiDropdown: {
    width: 340,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 6px 24px rgba(0,0,0,0.18)",
    overflow: "hidden",
  },
  notiHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    background: "#630063",
  },
  notiHeaderTitle: {
    color: "#fff",
    fontWeight: 600,
    fontSize: 14,
  },
  clearBtn: {
    background: "none",
    border: "1px solid rgba(255,255,255,0.5)",
    color: "#fff",
    borderRadius: 4,
    padding: "2px 8px",
    fontSize: 12,
    cursor: "pointer",
  },
  notiBody: {
    maxHeight: 380,
    overflowY: "auto",
    padding: "8px 0",
  },
  notiSectionHeader: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px 4px",
    borderBottom: "1px solid #f0e8f0",
  },
  notiSectionTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: "#555",
    flex: 1,
  },
  notiSectionCount: {
    fontSize: 12,
    fontWeight: 700,
    color: "#e74c3c",
    background: "#fdecea",
    borderRadius: 10,
    padding: "1px 7px",
  },
  notiItem: {
    padding: "8px 16px 8px 28px",
    borderBottom: "1px solid #faf5fa",
    transition: "background 0.15s",
    cursor: "pointer",
  },
  notiCaseNo: {
    fontSize: 13,
    fontWeight: 600,
    color: "#333",
  },
  notiDate: {
    fontSize: 12,
    color: "#888",
    marginTop: 2,
  },
  notiFooter: {
    padding: "10px 16px",
    textAlign: "center",
    borderTop: "1px solid #f0e8f0",
    background: "#faf5fa",
  },
  viewAllLink: {
    color: "#630063",
    fontWeight: 500,
    fontSize: 13,
  },
};

export default AppLayout;
